import * as React from "react";
import {FontAwesomeIcon}        from "@fortawesome/react-fontawesome";
import {faRotateLeft, faSignHanging, faBed, faBath, faExpand, faTag, faMapPin, faFileLines} from "@fortawesome/free-solid-svg-icons";

import "./property-data-card.scss";

import {cs}                  from "@Common/react/chain-services";
import {UseState}            from "@Common/react/use-state";
import {consumeContext}      from "@Common/react/context";
import {CustomStateSelector} from "./custom-state-selector";

export const PropertyDataCard = ({idOrder, listing, propertyData, propertyDataChangeHandler, refreshPropertyWizardData}) => cs(
    consumeContext("apis"),
    ["revertPropertyData", ({apis}, next) => next(async () => {
        let propertyData = {
            event: "",
            beds: listing?.bedrooms ?? "",
            baths: listing?.bathrooms ?? "",
            squareFootage: listing?.lotSizeSquareFeet ?? "",
            price: listing?.listedPrice ?? "",
            description: listing?.description ?? "",
            street: listing?.location?.streetAddress ?? "",
            line2: listing?.location?.unitNumber ?? "",
            city: listing?.location?.city ?? "",
            state: listing?.location?.state ?? "",
            zip: listing?.location?.zip ?? "",
            additionalContext: "",
            aggregateSummary: "",
        };
        await apis.next.gpt.savePropertyWizardData({
            idOrder: parseInt(idOrder),
            data: propertyData,
        });
        refreshPropertyWizardData();
    })],

    ({revertPropertyData}) => (
        <div className="property-data-card-b97">
            <div className="section-title">
                <div>Property Data</div>
                <div className="icon-and-text" onClick={revertPropertyData}>
                    <FontAwesomeIcon icon={faRotateLeft} /> Revert
                </div>
            </div>
            <div className="property-field-and-label">
                <div className="property-label"><FontAwesomeIcon icon={faSignHanging} />Event</div>
                <input
                    type="text"
                    name="event"
                    value={propertyData?.value?.event}
                    onChange={(e) => propertyDataChangeHandler(e)}
                    xd-qa-type="text_field"
                    xd-qa-name="Event"
                />
            </div>
            <div className="property-field-and-label">
                <div className="property-label"><FontAwesomeIcon icon={faBed} />Beds</div>
                <input
                    type="number"
                    name="beds"
                    value={propertyData?.value?.beds}
                    onChange={(e) => propertyDataChangeHandler(e)}
                    xd-qa-type="text_field"
                    xd-qa-name="Beds"
                />
            </div>
            <div className="property-field-and-label">
                <div className="property-label"><FontAwesomeIcon icon={faBath} />Baths</div>
                <input
                    type="number"
                    name="baths"
                    value={propertyData?.value?.baths}
                    onChange={(e) => propertyDataChangeHandler(e)}
                    xd-qa-type="text_field"
                    xd-qa-name="Baths"
                />
            </div>
            <div className="property-field-and-label">
                <div className="property-label"><FontAwesomeIcon icon={faExpand} />Square Footage</div>
                <input
                    type="number"
                    name="squareFootage"
                    value={propertyData?.value?.squareFootage}
                    onChange={(e) => propertyDataChangeHandler(e)}
                    xd-qa-type="text_field"
                    xd-qa-name="Square-Footage"
                />
            </div>
            <div className="property-field-and-label">
                <div className="property-label"><FontAwesomeIcon icon={faTag} />Price</div>
                <input
                    type="number"
                    name="price"
                    value={propertyData?.value?.price}
                    onChange={(e) => propertyDataChangeHandler(e)}
                    xd-qa-type="text_field"
                    xd-qa-name="Price"
                />
            </div>
            <hr/>
            <div className="address-container">
                <div className="property-label"><FontAwesomeIcon icon={faMapPin} />Address</div>
                <input
                    type="text"
                    name="street"
                    value={propertyData?.value?.street}
                    onChange={(e) => propertyDataChangeHandler(e)}
                    xd-qa-type="text_field"
                    xd-qa-name="Street"
                />
                <input
                    type="text"
                    name="line2"
                    value={propertyData?.value?.line2}
                    onChange={(e) => propertyDataChangeHandler(e)}
                    xd-qa-type="text_field"
                    xd-qa-name="Line2"
                />
                <div className="city-state-zip">
                    <input
                        type="text"
                        className="city"
                        name="city"
                        value={propertyData?.value?.city}
                        onChange={(e) => propertyDataChangeHandler(e)}
                        xd-qa-type="text_field"
                        xd-qa-name="City"
                    />
                    <CustomStateSelector
                        propertyData={propertyData}
                        propertyDataChangeHandler={propertyDataChangeHandler}
                    />
                    <input
                        type="number"
                        name="zip"
                        className="zip"
                        value={propertyData?.value?.zip}
                        onChange={(e) => propertyDataChangeHandler(e)}
                        xd-qa-type="text_field"
                        xd-qa-name="Zip"
                    />
                </div>
                <hr/>
                <div className="property-label"><FontAwesomeIcon icon={faFileLines} />MLS Description</div>
                <input
                    type="text"
                    className="description-input"
                    name="description"
                    id="description-input-j73"
                    value={propertyData?.value?.description}
                    onChange={(e) => propertyDataChangeHandler(e)}
                    onFocus={() => {
                        // hide current input & display textArea when editing description value
                        document.getElementById("description-input-j73").classList.add("hidden");
                        document.getElementById("description-textarea-j73").classList.remove("hidden");
                        document.getElementById("description-textarea-j73").focus();
                    }}
                    onBlur={() => {

                    }}
                    xd-qa-type="text_field"
                    xd-qa-name="Description"
                />
                <textarea
                    className="description-textarea hidden"
                    name="description"
                    id="description-textarea-j73"
                    value={propertyData?.value?.description}
                    onChange={(e) => propertyDataChangeHandler(e)}
                    onBlur={() => {
                        // hide this textarea and display description field as an input when not editing value
                        document.getElementById("description-textarea-j73").classList.add("hidden");
                        document.getElementById("description-input-j73").classList.remove("hidden");
                    }}
                    xd-qa-type="text_field"
                    xd-qa-name="Description"
                />
            </div>
        </div>
    )
)